export class CommissionJureEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        jury: { key: 'jury', optional: true },
        nom: { key: 'nom', optional: true, default: '' },
        college: { key: 'college', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        codePostal: { key: 'codePostal', optional: true, default: '' },
        ville: { key: 'ville', optional: true, default: '' },
        mail: { key: 'mail', optional: true, default: '' },
        telephone: { key: 'telephone', optional: true, default: '' },
        portable: { key: 'portable', optional: true, default: '' },
        statut: { key: 'statut', optional: true, default: '' }
    };

    id: number;
    jury: number;
    nom: string;
    college: string;
    adresse: string;
    codePostal: string;
    ville: string;
    mail: string;
    telephone: string;
    portable: string;
    statut: string;
}
